import qs from "qs";
import React from "react";
import { type FilterByTypes } from "./components/filterby";
import { type Font, type Theme } from "./models";

export const getEmbedUrl = (clientFriendlyId: string, displayPagination: boolean, displayHeader: boolean, locale: string, font: Font, perPage: string, filterType: FilterByTypes, filterIds: number[], theme: Theme, pastShowDays: number, upcomingShowDays: number, includeCancelled: boolean): string => {
  const queryParamsObj = {
    theme,
    font,
    lang: locale,
    per_page: perPage,
    upcoming_limit: upcomingShowDays,
    cancelled: includeCancelled,
    ...(!displayHeader && { header: false }),
    ...(filterType === "MultipleArtists" && { artistIds: filterIds }),
    ...(filterType === "Productions" && { productionIds: filterIds }),
    ...(displayPagination && { page: 1 }),
    ...(pastShowDays && { past_limit: pastShowDays })
  };

  const queryString = qs.stringify(queryParamsObj, { arrayFormat: "comma" });

  return `${site.forClientsBaseUrl}/embed/v1/shows/${clientFriendlyId}?${queryString}`;
};

export const getRawJsonUrl = (clientFriendlyId: string, locale: string, perPage: string, filterType: FilterByTypes, filterIds: number[], pastShowDays: number, upcomingShowDays: number, includeCancelled: boolean): string => {
  const queryParamsObj = {
    lang: locale,
    per_page: perPage,
    upcoming_limit: upcomingShowDays,
    cancelled: includeCancelled,
    // Conditionally add artist ids param to object
    ...(filterType === "MultipleArtists" && { artistIds: filterIds }),
    ...(filterType === "Productions" && { productionIds: filterIds }),
    ...(pastShowDays && { past_limit: pastShowDays }),

    page: 1
  };

  const queryString = qs.stringify(queryParamsObj, { arrayFormat: "comma" });

  return `${site.forClientsBaseUrl}/api/v1/shows/${clientFriendlyId}?${queryString}`;
};

export const getEmbedCode = ({ url, height, width }: { url: string, height: string, width: string }) => <embed src={url} style={{ height, width }} />;

export const getEmbedCodeText = ({ url, height, width }: { url: string, height: string, width: string }) => "<embed src=\"" + url + "\" width=\"" + width + "\" height=\"" + height + "\" frameborder=\"0\" />";
